import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, formValueSelector, getFormSyncErrors } from 'redux-form';
import { connect ,useSelector} from 'react-redux';
import { Button, Table } from 'reactstrap';
import moment from 'moment';
import _ from 'lodash';
import cx from 'classnames';
import {   getTechnicians,getCurrentJob,getTreatmentType, getShowMissingEndPhaseMessage} from '../selectors';
import {
  CONCENTRATION_READING_PHASE_START,
  CONCENTRATION_READING_PHASE_DURING,
  CONCENTRATION_READING_PHASE_END,
} from '../../../../constants/ConcentrationReadingPhase';

import * as Validators from '../../../../util/Validators';
import * as operationsApi from '../../../../api/operationsApi';
import { confirmAlert } from '../../../../util/Alerts';

import PlainTextField from '../../../fields/PlainTextField';
import RenderField from '../../../fields/RenderField';
import SearchableSelect from '../../../fields/SearchableSelect';
import DatePickerField from '../../../fields/DatePickerField';
import { getCompetentTechnicians,getTechByArea } from '../../../../selectors/technicianSelectors';
import {  isImportOrExportAndContainer,isImportOrExportContainerAndMethylBromide} from '../../../../util/JobTypeHelper';
import styles from './styles.module.scss';

const propTypes = {
  fields: PropTypes.object,
  readOnly: PropTypes.bool,
  fieldValue: PropTypes.func.isRequired,
  jobId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onEditing: PropTypes.func.isRequired,
  meta: PropTypes.object,
};

function shouldShowWarning(field, fieldValue) {
  const std = +fieldValue(`${field}.stdgramPerCubicMetre`);
  const topUpDose = +fieldValue(`${field}.topupDose`);
  const jobType = +fieldValue(`${field}.job`);
  return (
    Boolean(std) &&
    !topUpDose &&
    [1, 2, 3].some((i) => {
      const value = +fieldValue(`${field}.reading${i}`);
      return value && value < std;
    })
  );
}
    /*let selector = formValueSelector('treatmentResultRecordsForm') ;
    const concentrationReadingItem = useSelector(state =>
  selector(state, 'concentrationReadingItem')
);*/
function getConcentrationReadingItem(concentrationReadingItems, currentIndex) {
  const phaseOptions = [
    { value: 0, label: 'Start' },
    { value: 1, label: 'During' },
    { value: 2, label: 'End' },
  ];

  const phases = (concentrationReadingItems || [])
    .filter((item, itemIndex) => itemIndex !== currentIndex)
    .map(item => Number(item.phase))
    .filter(phase => !Number.isNaN(phase));

  return phaseOptions.filter(
    option => !phases.includes(option.value)
  );
}

function containerIsUsed(currentJob){
   let trr = currentJob.treatmentResultRecords;
   let cri = trr.flatMap((item) =>item.concentrationReadingItem||[])
  let usedContainers = [
  ...new Map(
    cri.map(item => [
      item.containerNumber,
      {
        containerNumber: item.containerNumber,
        id: item.id
      }
    ])
  ).values()
];
  return usedContainers

}  
/*
function getContainerNumbers(concentrationReadingItems, markings, currentJob){  
 var usedContainers =  containerIsUsed(currentJob)
     console.log('usedContainer',usedContainers)
  //let containerNumber = concentrationReadingItems.map((items)=> {return { containerNumber: items.containerNumber, id: items.id }})
    let containerNumber = concentrationReadingItems.map((items)=>  items.containerNumber)
        let phases = concentrationReadingItems.map((items)=>  items.phase)
        let hasendPhase = phases.some(items=>items==2)
        let hasstartPhase = phases.some(items=>items==0)  
        let startPhaseContainer = concentrationReadingItems.filter((items)=>items.phase==0).map((items)=>  items.containerNumber);


  //containerNumber = containerNumber.filter((item)=> item != null && usedContainers.includes(item));

  let markings2 = [];
       for(var i =0;i<containerNumber.length;i++){
       var containerNumberAr ={value:'' ,label:''}
        containerNumberAr.value = containerNumber[i];
        containerNumberAr.label = containerNumber[i];
       markings2.push(containerNumberAr)
     }
     
        if(hasstartPhase && !hasendPhase){
          console.log('startPhaseContainer',startPhaseContainer)
        }
      markings2 = markings2.filter((item) => item.value != null && !usedContainers.includes(item)).slice(0,1);
          //we need to include contianer numbers that are currently being used in the start phase i.e if the id == start.

      //get phases 


     if(markings2.length<=0){

      markings2 = markings.filter((item) => item.value != null && !usedContainers.includes(item)).slice(0,1);
      console.log('markings2inside',markings2)
     }

  return markings2;
    }*/




class ConcentrationReadingsFieldArrayItem extends Component {
  render() {
    const {
      field,
      fieldValue,
      fieldError,
      readOnly,
      isEditing,
      onEdit,
      onDone,
      onRemove,
      jobtypename,
      currentJob,
      technicians,
      treatmentType,
      concentrationReadingItems,
      index,
      selectedRecord
    } = this.props;

      const isCoveredContainer = null;//currentJob.treatmentTypeDetails.covered?currentJob.treatmentTypeDetails.covered:null
    const phaseOptions = [
      { value: CONCENTRATION_READING_PHASE_START, label: 'Start' },
      { value: CONCENTRATION_READING_PHASE_DURING, label: 'During' },
      { value: CONCENTRATION_READING_PHASE_END, label: 'End' },
    ];
    
    var markingOptions = currentJob.treatmentTypeDetails.markings;
    const doubled = markingOptions.map((marking,index) =>  marking.containerNumber);
     const markings2=[] ;
    for(var i =0;i<doubled.length;i++){
       var containerNumber ={value:'' ,label:''}
        containerNumber.value = doubled[i];
        containerNumber.label = doubled[i];
       markings2.push(containerNumber)
     }
     const isContainer = isImportOrExportAndContainer(currentJob.type)
     const techByArea = getTechByArea(technicians,currentJob.areaId);
 
     const competentTechs = getCompetentTechnicians(
       techByArea,
       treatmentType,
       currentJob.treatmentTypeDetails.commodity,
       currentJob.treatmentDetails.standardId,
       currentJob.typeId,
       currentJob.areaId,
     );
   const showWarning = isCoveredContainer?null:shouldShowWarning(field, fieldValue);
   

  //  const showWarning = shouldShowWarning(field, fieldValue);
   
    const hasError = Boolean(fieldError(field));

    return (
      <tr>
        <td>
          {isEditing && isImportOrExportContainerAndMethylBromide(currentJob.type,currentJob.treatmentDetails.treatmentTypeId) ?(
                  <Field
                  name={`${field}.phase`}
                  component={SearchableSelect}
                  options={getConcentrationReadingItem(
                    concentrationReadingItems,
                    index
                  )}
                  valueKey="value"
                  labelKey="label"
                  placeholder="Phase"
                  className={styles.phaseSelect}
                />
  ):isEditing?  <Field
                  name={`${field}.phase`}
                  component={SearchableSelect}
                  options={phaseOptions}
                  valueKey="value"
                  labelKey="label"
                  placeholder="Phase"
                  className={styles.phaseSelect}
                /> : (
            <PlainTextField
              name={`${field}.phase`}
              value={
                phaseOptions[fieldValue(`${field}.phase`)] &&
                phaseOptions[fieldValue(`${field}.phase`)].label
              }
            />
          )}
        </td>
       
        <td>
          {isEditing ? (
            <Field
              name={`${field}.rikenID`}
              component={RenderField}
              type="text"
              placeholder="Riken ID"
            />
          ) : (
            <PlainTextField
              name={`${field}.rikenID`}
              value={fieldValue(`${field}.rikenID`)}
            />
          )}
        </td>
        <td>
          {isEditing ? (
            <Field
              name={`${field}.readingDateTime`}
              component={DatePickerField}
              defaultToEmpty
              showTimeSelect
              type="text"
              placeholder="Date/Time"
              validate={[Validators.isValidDateAndTime]}
              timeIntervals={1}
            />
          ) : (
            <PlainTextField
              name={`${field}.readingDateTime`}
              value={
                fieldValue(`${field}.readingDateTime`) &&
                moment(fieldValue(`${field}.readingDateTime`)).format('DD/MM HH:mm',)
              }
            />
          )}
        </td>
        <td>
          {isEditing ? (
            <Field
              name={`${field}.stdgramPerCubicMetre`}
              component={RenderField}
              type="number"
              placeholder="Std g/m3"
              validate={[Validators.number]}
            />
          ) : (
            <PlainTextField
              name={`${field}.stdgramPerCubicMetre`}
              value={fieldValue(`${field}.stdgramPerCubicMetre`)}
            />
          )}
        </td>
        <td>
          {isEditing ? (
            <Field
              name={`${field}.reading1`}
              component={RenderField}
              type="number"
              placeholder={jobtypename !== 'MB Logs In Hold'?"1 Front":"Fwd     "}
              validate={isCoveredContainer?null:[ Validators.number, Validators.evenDecimal]}
              manualError={isCoveredContainer?null: fieldError(`${field}.reading1`)}
            />
          ) : (
            <PlainTextField
              name={`${field}.reading1`}
              value={fieldValue(`${field}.reading1`)}
            />
          )}
        </td>
        <td>
          {isCoveredContainer?null: isEditing ? (
            <Field
              name={`${field}.reading2`}
              component={RenderField}
              type="number"
              placeholder={jobtypename !== 'MB Logs In Hold'?"2 Middle":"Aft      "}
              validate={[Validators.number, Validators.evenDecimal]}
              manualError={fieldError(`${field}.reading2`)}
            />
          ) : (
            <PlainTextField
              name={`${field}.reading1`}
              value={fieldValue(`${field}.reading2`)}
            />
          )}
        </td>
        <td>
          {isCoveredContainer?null:isEditing && jobtypename !== 'MB Logs In Hold' ? (
            <Field
              name={`${field}.reading3`}
              component={RenderField}
              type="number"
              placeholder="3 Back"
              validate={[Validators.number, Validators.evenDecimal]}
              manualError={fieldError(`${field}.reading3`)}
            />
          ) :jobtypename !== 'MB Logs In Hold'? (
            <PlainTextField
              name={`${field}.reading1`}
              value={fieldValue(`${field}.reading3`)}
            />
          ):null}
        </td>
        <td>
          {isEditing ? (
            <Field
              name={`${field}.topupDose`}
              component={RenderField}
              type="number"
              placeholder="Top-up Dose"
              validate={[Validators.number]}
            />
          ) : (
            <PlainTextField
              name={`${field}.topupDose`}
              value={fieldValue(`${field}.topupDose`)}
            />
          )}
        </td>
        <td>
          {isContainer ? isEditing ? (
            
            <Field
              name={`${field}.technician`}
              component={SearchableSelect}
              options={competentTechs}
              valueKey="name"
              labelKey="name"
              placeholder="Technicians"
              validate={Validators.dropDownNumber}
             
            />
          ) : (
            <PlainTextField
              name={`${field}.technician`}
              value={fieldValue(`${field}.technician`)
              }
            />
          ):null}
        </td>
        
        <td>
          {hasError && (
            <span className={styles.errorIcon}>
              <i aria-hidden="true" className="material-icons">
                error
              </i>
            </span>
          )}
          {showWarning && !hasError && (
            <span className={styles.warningIcon}>
              <i aria-hidden="true" className="material-icons">
                warning
              </i>
            </span>
          )}
        </td>
        {!readOnly && (
          <td>
            {isEditing && (
              <Button
                className={styles.iconButton}
                outline
                onClick={onDone}
                color={hasError ? 'disabled' : 'success'}
                disabled={hasError}
              >
                <i aria-hidden="true" className="material-icons">
                  check_outline
                </i>
              </Button>
            )}
            {!isEditing && (
              <Button
                className={styles.iconButton}
                outline
                color="primary"
                onClick={onEdit}
              >
                <i aria-hidden="true" className="material-icons">
                  edit_outline
                </i>
              </Button>
            )}
            <Button
              className={styles.iconButton}
              outline
              color="danger"
              onClick={onRemove}
            >
              <i aria-hidden="true" className="material-icons">
                delete_outline
              </i>
            </Button>
          </td>
        )}
      </tr>
    );
  }
}
ConcentrationReadingsFieldArrayItem.propTypes = {
  field: PropTypes.string.isRequired,
  form: PropTypes.string.isRequired,
  fieldValue: PropTypes.func.isRequired,
  fieldError: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  isEditing: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

const Item = connect((state, props) => ({
  currentJob: getCurrentJob(state),
  technicians: getTechnicians(state),
  treatmentType: getTreatmentType(state),
  fieldValue: (field) => formValueSelector(props.form)(state, field),
  fieldError: (field) => _.get(getFormSyncErrors(props.form)(state), field),
}))(ConcentrationReadingsFieldArrayItem);

// eslint-disable-next-line react/no-multi-comp
class ConcentrationReadingsFieldArray extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: [],
    };
  }

  render() {
    const {
      fields,
      readOnly = false,
      fieldValue,
      meta,
      jobId,
      onChange,
      onEditing,
      job,
    } = this.props;
    var isCovered = false;//job.treatmentTypeDetails.covered?job.treatmentTypeDetails.covered:false

    const jobTypeName = job.type.name;
    const isContainer =  isImportOrExportAndContainer(job.type)
    const count = fields ? fields.length : 0;
    // We need to do reduce here because fields is actually not an array
    var showWarning =
      fields && 
      fields.reduce(
        (acc, field) => acc || shouldShowWarning(field, fieldValue),
        false,
      );
      if(isCovered){
showWarning = false;
      }

    return (
      <div className={styles.concentrationReadingsFieldArray}>
        <Table hover>
          <thead>
            <tr>
              <th style={{ width: 105 }}>Phase</th>
              <th>Riken ID</th>
              <th>Date/Time</th>
              <th>Std g/m3</th>
              <th style={{ textAlign: 'center' }}>{jobTypeName==='MB Logs In Hold'?"Fwd":isCovered?"Line": "1 Front g/m3" } </th>
              <th style={{ textAlign: 'center' }}>{isCovered?null:jobTypeName==='MB Logs In Hold'?"Aft":"2 Middle g/m3"}</th>
              <th style={{ textAlign: 'center' }}>{isCovered?null:jobTypeName === 'MB Logs In Hold'?"":"3 Back g/m3"}</th>
              <th style={{ textAlign: 'center' }}>Top-up Dose</th>
              {isContainer?<th style={{ width: 150 }}>Technician</th>:null}
              <th>&nbsp;</th>
              {!readOnly && (
                <th style={{ width: 100 }}>
                  <Button
                    className={styles.iconButton}
                    outline
                    onClick={(e) => {
                      fields.push({ jobId });
                      this.setState(
                        (state) => ({
                          editing: [...state.editing, count],
                        }),
                        () => {
                          onEditing(true);
                        },
                      );
                    }}
                    color="primary"
                  >
                    <i aria-hidden="true" className="material-icons">
                      add_outline
                    </i>
                  </Button>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {count === 0 && (
              <tr>
                <td align="center" colSpan={readOnly ? 8 : 9}>
                  There is no data to display - ConcentrationReadingField
                </td>
              </tr>
            )}
            {fields.map((field, index) => (
              <Item
                key={index}
                index={index}
                field={field}
                form={meta.form}
                jobtypename = {jobTypeName}
                concentrationReadingItems={fields.getAll() || []}
                readOnly={readOnly}
                isEditing={ this.state.editing.includes(index)}
                onEdit={() => {
                  this.setState(
                    (state) => ({
                      editing: [...state.editing, index],
                    }),
                    () => {
                      onEditing(true);
                    },
                  );
                }}
                onDone={() => {
                  this.setState(
                    (state) => ({
                      editing: state.editing.filter((i) => i !== index),
                    }),
                    () => {
                      onEditing(this.state.editing.length > 0);
                      const updatedField = fields.get(index);
                      const all = fields.getAll();
                     if( onChange )//&&
                      {
                        onChange([
                          ...all.slice(0, index),
                          updatedField,
                          ...all.slice(index + 1),
                        ]);
                    }
                   else {
                    console.log('onChange is not defined.');
                  }
                }
                  );
                }}
              
                onRemove={async () => {
                  const confirm = await confirmAlert(
                    'Delete',
                    'Are you sure you want to delete this record?',
                  );
                  if (confirm) {
                    const item = fields.get(index);
                    if (item.id) {
                      try {
                        await operationsApi.deleteConcentrationReadingRecord(
                          item.id,
                        );
                      } catch (err) {
                        /* noop */
                      }
                    }
                    fields.remove(index);
                    this.setState(
                      (state) => ({
                        editing: state.editing.filter((i) => i !== index),
                      }),
                      () => {
                        onEditing(this.state.editing.length > 0);
                      },
                    );
                  }
                }}
              />
            ))}
          </tbody>
        </Table>
        {showWarning ? (
          <p className={cx(styles.note, styles.legend)}>
            <span className={styles.warningIcon}>
              <i aria-hidden="true" className="material-icons">
                warning
              </i>
            </span>
            <span> - Check entries or Top up required</span>
          </p>
        ):null}
        <p className={styles.note}>
          If top up is within 2hrs of the end of treamtnent, record readings after top up and 4hrs after treatment period.
        </p>
      </div>
    );
  }
}
ConcentrationReadingsFieldArray.propTypes = propTypes;

export default connect((state, props) => {
  const selector = formValueSelector(props.meta.form);

  return {
    fieldValue: (field) => selector(state, field),
    selectedRecord: selector(state, 'id'),

    concentrationReadingItems: selector(
      state,
      'concentrationReadingItem'
    ),
  };
})(ConcentrationReadingsFieldArray);